import { TypedDataDomain, TypedDataField } from '@ethersproject/abstract-signer'
import { Bytes } from '@ethersproject/bytes'

import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { useCallback, useMemo } from 'react'
import { noSigner } from 'shared/constants/errors'

/*
      Fix last two bytes of signature for Ledger (1b or 1c is required
      but with Ledger + Metamask or Ledger + WalletConnect we'll always
      get 00 or 01). Signature will be valid only if last two bytes are
      1b or 1c (27 or 28 in decimal)
*/
function fixSignature(signature: string) {
  const lastTwoBytes = signature.slice(-2)
  if (lastTwoBytes === '1b' || lastTwoBytes === '1c') {
    return signature
  }
  const lastTwoBytesUpdated = lastTwoBytes === '00' ? '1b' : '1c'
  return `${signature.slice(0, -2)}${lastTwoBytesUpdated}`
}

export const useWeb3Signer = () => {
  const { library } = useWeb3()

  const signer = useMemo(() => {
    if (!library) return null

    // if (connectedWalletName === 'ledger' && 'signer' in provider) {
    //   return (provider as any).signer as Signer
    // }

    return library.getSigner()
  }, [library])

  const signMessage = useCallback(
    async (message: string | Bytes) => {
      if (!signer) throw Error(noSigner)
      return signer.signMessage(message).then(fixSignature)
    },
    [signer],
  )

  const signTypedData = useCallback(
    async (
      domain: TypedDataDomain,
      types: Record<string, TypedDataField[]>,
      value: Record<string, any>,
    ) => {
      if (!signer) throw Error(noSigner)
      return signer._signTypedData(domain, types, value).then(fixSignature)
    },
    [signer],
  )

  return { signer, signMessage, signTypedData }
}
